<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.add visit") }}</h2>
    </div>
    <div class="col-lg-2">
      <i class="fa fa-times close my-0" @click="onclosed()"></i>
    </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content p-3">
      <div class="form-group row mb-0">
        <div class="col-lg-4 my-2">
          <label class="col-form-label"
            >{{ $t("navigations.visit no") }} <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input
            type="text"
            class="form-control"
            placeholder=""
            v-model="values.visitNo"
            maxlength="1000"
          />
          <span class="errormsg" v-if="errors[0] == false">
            {{ $t("navigations.please enter visit no") }}
          </span>
        </div>
        <div class="col-lg-4 my-2">
          <label class="col-form-label"
            > {{ $t("navigations.visit name") }}<sup><i class="fa fa-asterisk required"></i></sup
          ></label>
          <input
            type="text"
            class="form-control"
            placeholder=""
            v-model="values.visitFormName"
            maxlength="1000"
          />
          <span class="errormsg" v-if="errors[1] == false"
            >{{ $t("navigations.please enter visit name") }}</span
          >
        </div>
        <div class="col-lg-4 my-2">
          <label class="col-form-label"> {{ $t("navigations.visit type") }} <sup><i class="fa fa-asterisk required"></i></sup
          ></label>
          <select
            class="form-select"
            placeholder=""
            v-model="values.visitType"
             valueProp="VisitTypeName"
            
          >
            <option
              v-for="options in visitList"
              :key="options.typename"
            >
            {{options.typename}}
              
            </option>
          </select>
           <span class="errormsg" v-if="errors[2] == false"
            >{{ $t("navigations.please select a visit type") }}</span
          >
        </div>
        <div class="col-lg-4 my-2">
          <label class="col-form-label">{{ $t("navigations.pre-visit") }} </label>
          <input
            type="number"
            min="0"
            class="form-control"
            placeholder=""
            v-model="values.preVisit"
            maxlength="4"
            @change.prevent="numberonlyvalidation('preVisit')"
            @keydown="preventNonNumeric"
          />
          <span class="errormsg" v-if="numerrors['preVisit'] == false"
            >{{ $t("navigations.please enter a number") }}</span
          >
        </div>
        <div class="col-lg-4 my-2">
          <label class="col-form-label">{{ $t("navigations.post-visit") }} </label>
          <input
            type="number"
            min="0"
            class="form-control"
            placeholder=""
            v-model="values.postVisit"
            maxlength="4"
            @change.prevent="numberonlyvalidation('postVisit')"
            @keydown="preventNonNumeric"
          />
          <span class="errormsg" v-if="numerrors['postVisit'] == false"
            >{{ $t("navigations.please enter a number") }}</span
          >
        </div>
        <!--          <div class="col-lg-4 my-2">
                    <label class="col-form-label"> Visit period </label>
                    <input type="text" class="form-control" placeholder="Visit period " v-model="values.visitPeriod" @change.prevent="numberonlyvalidation('visitPeriod')">
                    <span class="errormsg" v-if="numerrors['visitPeriod'] == false">Please enter a number</span>
                </div>
-->
        <div class="col-lg-4 my-2">
          <label class="col-form-label"> {{ $t("navigations.visit period(days)") }}</label>
          <input
            type="number"
            min="0"
            class="form-control"
            placeholder=""
            v-model="values.visitDayPeriod"
            @input.prevent="limitInputLength('visitDayPeriod', 4)"
            @change.prevent="numberonlyvalidation('visitDayPeriod')"
            @keydown="preventNonNumeric"
          />
          <span class="errormsg" v-if="numerrors['visitDayPeriod'] == false"
            > {{ $t("navigations.please enter a number") }}</span
          >
        </div>

        <div class="col-lg-4 my-2">
          <label class="col-form-label"> {{ $t("navigations.visit period(weeks)") }} </label>
          <input
            type="number"
            min="0"
            class="form-control"
            placeholder=""
            v-model="values.visitWeekPeriod"
            @input.prevent="limitInputLength('visitWeekPeriod', 4)"
            @change.prevent="numberonlyvalidation('visitWeekPeriod')"
            @keydown="preventNonNumeric"
          />
          <span class="errormsg" v-if="numerrors['visitWeekPeriod'] == false"
            >{{ $t("navigations.please enter a number") }}</span
          >
        </div>
        <div class="col-lg-4 my-2">
          <label class="col-form-label"> {{ $t("navigations.visit period(months)") }} </label>
          <input
            type="number"
            min="0"
            class="form-control"
            placeholder=""
            v-model="values.visitMonthPeriod"
            @input.prevent="limitInputLength('visitMonthPeriod', 4)"
            @change.prevent="numberonlyvalidation('visitMonthPeriod')"
            @keydown="preventNonNumeric"
          />
          <span class="errormsg" v-if="numerrors['visitMonthPeriod'] == false"
            >{{ $t("navigations.please enter a number") }}</span
          >
        </div>
        <div class="col-lg-4 my-2">
          <label class="col-form-label"> {{ $t("navigations.visit period(years)") }} </label>
          <input
            type="number"
            min="0"
            class="form-control"
            placeholder=""
            v-model="values.visitYearPeriod"
            @input.prevent="limitInputLength('visitYearPeriod', 4)"
            @change.prevent="numberonlyvalidation('visitYearPeriod')"
            @keydown="preventNonNumeric"
          />
          <span class="errormsg" v-if="numerrors['visitYearPeriod'] == false"
            >{{ $t("navigations.please enter a number") }}</span
          >
        </div> <div class="col-lg-12 my-2">
          <label class="col-form-label">{{ $t("navigations.visit notes") }} </label>
          <input
            type="text"
            class="form-control"
            placeholder=""
            v-model="values.visitNotes"
            maxlength="1000"
          />
          </div>
        <div class="col-md-2 my-2">
          <div class="i-checks">
            <label class="mr-2">{{ $t("navigations.active") }}</label>
            <input type="checkbox" value="" v-model="values.active" />
          </div>
        </div>
        <div class="col-md-2 my-2">
          <div class="i-checkss">
            <label class="mr-2">{{ $t("navigations.subject visit") }}</label>
            <input type="checkbox" :checked="values.visitType == 'Patient Visit'" v-model="values.isPatientVisit" :disabled="values.visitType == 'Patient Visit'"/>
          </div>
        </div>

        <div class="col-lg-12 mb-2 d-flex justify-content-lg-end">
          <button
            class="cancel_btn btn-cor_rad py-1 px-4 mx-3"
            @click.prevent="clear()"
          >
           {{ $t("navigations.clear") }}
          </button>
          <button
            class="save_btn py-1 px-4"
            type="submit"
            @click.prevent="addVisit()"
          >
            {{ $t("navigations.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./addVisitComponent.js"></script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
@import "../../assets/savepages.css";
.wrapper-content {
  width: 100%;
}
textarea {
  width: 100%;
}
.imp {
  color: #ff0000;
  font-size: 7px;
}
.impcl {
  color: #ff4747;
  font-size: 25px;
  float: right;
}
.impcl:hover {
  color: #a30202;
  font-size: 25px;
  float: right;
}
.col-form-label {
  font-size: 14px;
}
.address {
  width: 100%;
}
.page-heading {
  display: flex !important;
  justify-content: space-between;
}
.form-select {
  border-radius: 0 !important;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}
</style>
